// extracted by mini-css-extract-plugin
export var boldText = "_73-4";
export var checkboxContainer = "_73-6";
export var closeIcon = "_73-i";
export var container = "_73-0";
export var drawer = "_73-8";
export var drawerContent = "_73-9";
export var extraSmallText = "_73-5";
export var fulfillmentGroupTable = "_73-e";
export var largeText = "_73-3";
export var loadingSpinnerContainer = "_73-j";
export var mediumText = "_73-2";
export var narrow = "_73-f";
export var notificationLink = "_73-l";
export var packageCheckIconContainer = "_73-7";
export var slideoutHeaderActions = "_73-g";
export var slideoutHeaderActionsShifted = "_73-h";
export var slideoutHeaderContainer = "_73-a";
export var slideoutModal = "_73-c";
export var stickyHeaderWrapper = "_73-b";
export var table = "_73-k";
export var tableContainer = "_73-d";
export var tertiaryText = "_73-1";